import { css } from 'styled-components';
import { isBreakpointToken, isTypographyToken } from './utils/index.js';
import { isResponsiveAggregateToken } from './utils/index.js';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_2_XL } from '../../tokens/sizing.generated.js';
const renderResponsive = (xs, sm, md, lg, xl, xxl) => {
    const generateStyles = (base, next, bp) => {
        const properties = {
            fontFamily: 'font-family',
            letterSpacing: 'letter-spacing',
            fontWeight: 'font-weight',
            textDecoration: 'text-decoration',
            fontSize: 'font-size',
            lineHeight: 'line-height',
            fontStretch: 'font-stretch'
        };
        const keys = Object.keys(properties);
        const hasStyles = Boolean(keys.filter((p) => xs[p] !== next[p]).length);
        const styles = keys
            .filter((p) => base[p] !== next[p])
            .map((p) => `${properties[p]}: ${next[p]};`)
            .join('');
        if (!hasStyles)
            return '';
        return `@media (min-width: ${bp}) { ${styles} }`;
    };
    return css `
    font-family: ${xs.fontFamily};
    letter-spacing: ${xs.letterSpacing};
    font-weight: ${xs.fontWeight};
    text-decoration: ${xs.textDecoration};
    font-size: ${xs.fontSize};
    line-height: ${xs.lineHeight};
    font-stretch: ${xs.fontStretch};

    ${generateStyles(xs, sm, SYS_BREAKPOINT_SM)}
    ${generateStyles(sm, md, SYS_BREAKPOINT_MD)}
    ${generateStyles(md, lg, SYS_BREAKPOINT_LG)}
    ${generateStyles(lg, xl, SYS_BREAKPOINT_XL)}
    ${generateStyles(xl, xxl, SYS_BREAKPOINT_2_XL)}
  `;
};
export const getTypographyStyles = (token) => {
    // If the token is an aggregated responsive object (xs..'2xl'), render responsive
    if (isResponsiveAggregateToken(token)) {
        return renderResponsive(token.xs, token.sm, token.md, token.lg, token.xl, token['2xl']);
    }
    if (isTypographyToken(token)) {
        // Fallback: render flat token as-is
        return css `
      font-family: ${token.fontFamily};
      letter-spacing: ${token.letterSpacing};
      font-weight: ${token.fontWeight};
      text-decoration: ${token.textDecoration};
      font-size: ${token.fontSize};
      line-height: ${token.lineHeight};
      font-stretch: ${token.fontStretch};
    `;
    }
    if (isBreakpointToken(token)) {
        const { xs, sm, md, lg, xl, xxl } = token.bp;
        return renderResponsive(xs, sm, md, lg, xl, xxl);
    }
    return undefined;
};
//# sourceMappingURL=index.js.map